module.exports = __webpack_public_path__ + "media/fonts/Highway-Gothic-Wide.ttf-48a1872500a38e2e0b55dcb1db1eb435.woff";